<nz-collapse *ngIf="thereIsRes == 0">
  <nz-collapse-panel nzHeader="Filter" [(nzActive)]="FilterActive">
    <app-wizard-filter-section [filterFields]="filterFields" (filterButtonClicked)="getReportResult()"
      [filterButtonIsLoading]="isLoading" [groupedFilterFields]="groupedFilterFields" [groupKeys]="groupKeys">
    </app-wizard-filter-section>
  </nz-collapse-panel>
  <nz-collapse-panel nzHeader="Result" [(nzActive)]="!FilterActive">
    <app-table-section [tableCols]="reportTableCols" [dataset]="dataTable.dataset" [tableName]="dataTable.name"
      [cellSettings]="cellSettings">
    </app-table-section>
  </nz-collapse-panel>
</nz-collapse>
